import type { FeatureThemeKey } from '@/lib/productBranding'

export type NavSectionKey =
  | 'manage'
  | 'practice'
  | 'advisory'
  | 'compliance'
  | 'integrations'
  | 'administration'

export type NavSectionConfig = {
  label: string
  order: number
  themeKey?: FeatureThemeKey
}

export const navSectionConfig: Record<NavSectionKey, NavSectionConfig> = {
  manage: {
    label: 'Manage',
    order: 10,
  },
  practice: {
    label: 'Practice Intel',
    order: 20,
    themeKey: 'practiceIntel',
  },
  advisory: {
    label: 'Advisory Intel',
    order: 30,
    themeKey: 'advisoryIntel',
  },
  compliance: {
    label: 'Compliance Intel',
    order: 40,
    themeKey: 'complianceIntel',
  },
  integrations: {
    label: 'Integrations',
    order: 50,
  },
  administration: {
    label: 'Administration',
    order: 60,
  },
}

export function getNavSectionConfig(sectionKey: string): NavSectionConfig | null {
  if (!(sectionKey in navSectionConfig)) return null
  return navSectionConfig[sectionKey as NavSectionKey]
}
